import { ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { provideToastr } from '@openng/ngx-toastr';
import { provideLottieOptions } from 'ngx-lottie';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideAppState } from './app/redux/state.module';
import { HttpRequestInterceptor } from './app/services/http-data/httprequest.interceptor';
import { SignalRService } from './app/services/signal-r/signal-r.service';
import { NgxCustomToasterComponent } from './app/element-components/ngx-custom-toaster/ngx-custom-toaster.component';
import { ErrorHandlerService } from './app/services/error-handler/error-handler.service';
import { reportGlobalException } from './app/services/error-handler/global-exception-telemetry';


bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled' })),
    provideHttpClient(withInterceptorsFromDi()),
    ...provideAppState(),
    provideToastr({
      toastComponent: NgxCustomToasterComponent,
      closeButton: true,
      positionClass: 'toast-bottom-left',
      newestOnTop: false,
      autoDismiss: false,
      disableTimeOut: true
    }),
    provideLottieOptions({ player: () => import('lottie-web') }),
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: SignalRService, useClass: SignalRService },
    DatePipe,
  ]
}).catch(err => reportGlobalException(err, 'bootstrap'));
